import React from "react";
import { BookOpenIcon, HeartHandshakeIcon, SproutIcon } from "lucide-react";
import { OfferLink } from "./OfferLink";
import { solutionBenefits } from "../data/landing";
const icons = [BookOpenIcon, HeartHandshakeIcon, SproutIcon];
const tones: Record<string, string> = {
  azure: "bg-azure-light text-azure",
  blush: "bg-blush-light text-terracotta",
  sage: "bg-sage-light text-sage-deep"
};
export function SolutionSection() {
  return <section className="bg-cream" data-id="element-187" data-mp="12rr9qr5kdd6">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-188" data-mp="3t8n49oa642yk">
        <div className="mx-auto max-w-3xl text-center" data-id="element-189" data-mp="3t8526b0tquiq">
          <h2 className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.6rem]" data-id="element-190" data-mp="aunpr2x5i5hx">
            De petites paraboles pour faire grandir leur foi… et renforcer vos
            liens.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-191" data-mp="ktd6uth83lx4">
            Découvrez une collection de plus de 50 paraboles chrétiennes
            illustrées, imaginées pour éveiller la curiosité des enfants et
            ouvrir des conversations sur les valeurs de la foi.
          </p>
        </div>

        <ul className="mt-12 grid gap-10 md:mt-16 md:grid-cols-3 md:gap-8" data-id="element-192" data-mp="3b9yxkq1q93fi">
          {solutionBenefits.map((benefit, i) => {
          const Icon = icons[i];
          return <li key={benefit.title} className="border-t border-ink/15 pt-6" data-id="element-193" data-mp="3kbyezjgnm9iz" data-mpi={i}>
                <span className={`flex h-12 w-12 items-center justify-center rounded-full ${tones[benefit.tone]}`} data-id="element-194" data-mp="3p8f5ulf8n1zr">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-195" data-mp="3u68bndcmptzi" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-ink md:text-2xl" data-id="element-196" data-mp="2w01loer9i20">
                  {benefit.title}
                </h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-197" data-mp="bvd580g77cet">{benefit.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-12 flex justify-center" data-id="element-198" data-mp="gty3vvfsxo15">
          <OfferLink variant="outline" data-id="element-199" data-mp="2cw1j33a5tbrv">Voir l’offre complète</OfferLink>
        </div>
      </div>
    </section>;
}